export default {
  title: "Support",
  rules: {
    note: "Bevor Sie eine Anfrage senden, lesen Sie bitte die Regeln:",
    rule_1: "1. Lesen Sie zunächst den Bereich {faq} (FAQ) — möglicherweise finden Sie die Antwort bereits dort.",
    rule_2: "2. Bei Zahlungsproblemen fügen Sie bitte unbedingt Transaktionsdetails bei (Datum, Betrag, Zahlungsmethode, Screenshots).",
    rule_3: "3. Bei Problemen beim Herunterladen von Dateien geben Sie bitte unbedingt die Links zu diesen Dateien an.",
    rule_4: "4. Bei Urheberrechtsfragen oder anderen Dateien, die gegen die Regeln verstoßen, wenden Sie sich an: {email}",
    rule_5: "5. Für Kooperationen, Partnerprogramme, Werbung und andere geschäftliche Anfragen schreiben Sie an: {email}",
    rule_6: "6. Eine Antwort kann je nach Komplexität der Anfrage und Auslastung des Supports zwischen 12 Stunden und 2 Werktagen dauern.",
    rules: "Regeln",
    faq: "häufig gestellte Fragen"
  },
  messages: {
    note: "*Es werden die letzten {count} Nachrichten angezeigt",
    you: "Sie",
    support: "Support",
    autoanswer_subject_is_over: "Der Chat wurde geschlossen, da Ihr Problem gelöst wurde.\nVielen Dank, dass Sie den Support kontaktiert haben."
  },
  inputs: {
    message: {
      placeholder: "Schreiben Sie Ihre Frage"
    },
    attachments: {
      btn: "{text} {formats}",
      attach_file: "Datei anhängen",
      attached_files: "Angehängte Dateien:"
    }
  },
  errors: {
    generic: "Fehler",
    invalid_file_type: "Nicht unterstütztes Dateiformat.",
    max_file_size_limit: "Datei ist zu groß. Wählen Sie eine kleinere Datei.",
    filename_too_long: "Dateiname ist zu lang",
    filename_invalid_chars: "Dateiname enthält ungültige Zeichen"
  },
  btn: {
    send: "Senden"
  }
};
